import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { Observable, from } from 'rxjs';

@Injectable()
export class AuthHttpConfigInterceptor implements HttpInterceptor {

  constructor(
    private auth: KeycloakService,
    @Inject('API_URL') private apiUrl: string
    ) {}

   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.url.lastIndexOf(this.apiUrl) === -1) {
        return next.handle(req);
    }

        // Et on utilise ce clone à la place de la requête d'origine, tout en masquant surveillant
        // certaines étapes pour afficher/masquer le spinner selon l'étape où se trouve la requête.
        return from(this.handle(req, next)) ;
    }

    async handle(req: HttpRequest<any>, next: HttpHandler) {

        const jetonAuthentification : string = await this.auth.getToken();
        const headersRequete = jetonAuthentification ? req.headers.set('Authorization', `Bearer ${jetonAuthentification}`) : req.headers ;

        const cloneRequete = req.clone({
            withCredentials: true,
            headers: headersRequete
        });

        return next.handle(cloneRequete).toPromise();
    }
}

